<app-loading *ngIf="isLoading"></app-loading>

<mat-card *ngIf="simulation$ | async as simulation">
  <mat-card-title>
    <span i18n>Coverage areas</span>
    <app-help topic="COVERAGE_AREA"></app-help>
  </mat-card-title>
  <mat-card-subtitle *ngIf="simulation?.areas_definition.length" i18n>
    {{simulation.areas_definition.length}} areas and {{simulation.attendance_rates.length}} economic classes
  </mat-card-subtitle>
  <mat-card-content>
    <div *ngIf="!simulation?.areas_definition.length" i18n>
      Click with right mouse button to create areas.
    </div>
    <p *ngIf="intersection">
      <mat-error i18n>Areas with intersection.</mat-error>
    </p>
  </mat-card-content>
  <div fxLayout="column" fxLayoutGap="8px">

    <button class="app-block" mat-raised-button (click)="classify()" i18n-title
      title="Classification of Collective Properties" i18n>
      CLASSIFICATION
    </button>
    <button class="app-block" mat-raised-button (click)="validate()"
      [disabled]="!simulation.areas_definition.length || intersection || !simulation.attendance_rates.length" i18n-title
      title="Change attendance rates by economic class" i18n>
      RATES
    </button>
    <button class="app-block" mat-raised-button (click)="close()" i18n-title title="Close coverage area edition" i18n>
      CLOSE
    </button>

  </div>
</mat-card>
